<template>
  <ParksFinder />
</template>

<script>
import ParksFinder from '@/components/Pages/Parks/Finder/Finder.vue'

export default {
  components : {
    ParksFinder
  }
}
</script>